var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBlockerImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 60,
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M30 2.28882e-05C13.44 2.28882e-05 0 13.44 0 30C0 46.56 13.44 60 30 60C46.56 60 60 46.56 60 30C60 13.44 46.56 2.28882e-05 30 2.28882e-05ZM30 9.00002C34.98 9.00002 39 13.02 39 18C39 22.98 34.98 27 30 27C25.02 27 21 22.98 21 18C21 13.02 25.02 9.00002 30 9.00002ZM30 51.6C22.5 51.6 15.87 47.76 12 41.94C12.09 35.97 24 32.7 30 32.7C35.97 32.7 47.91 35.97 48 41.94C44.13 47.76 37.5 51.6 30 51.6Z",
  fill: "lightgrey"
})));
export { SvgBlockerImage as ReactComponent };
export default __webpack_public_path__ + "a5ed700682ee4b090c0ba3c786acba9b.svg";